import React, { useEffect, useRef } from "react";
import L from "leaflet";

// Fix default marker icons
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

export const MapView = ({ markers = [], center = [52.1, 5.29], zoom = 7, onMarkerClick, height = "100%" }) => {
  const ref = useRef(null);
  const mapRef = useRef(null);
  const layerRef = useRef(null);

  useEffect(() => {
    if (!ref.current || mapRef.current) return;
    mapRef.current = L.map(ref.current, { scrollWheelZoom: false }).setView(center, zoom);
    L.tileLayer("https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png", {
      attribution: "© OpenStreetMap © CARTO", maxZoom: 19,
    }).addTo(mapRef.current);
    layerRef.current = L.layerGroup().addTo(mapRef.current);
    return () => { mapRef.current && mapRef.current.remove(); mapRef.current = null; };
  }, []);

  useEffect(() => {
    if (!layerRef.current) return;
    layerRef.current.clearLayers();
    const valid = markers.filter((m) => m.lat && m.lng);
    valid.forEach((m) => {
      const icon = L.divIcon({
        className: "",
        html: `<div style="background:#E11D2A;color:#fff;padding:4px 8px;border-radius:6px;font-weight:700;font-size:12px;box-shadow:0 2px 8px rgba(0,0,0,.25);white-space:nowrap">€${m.pay}</div>`,
        iconSize: [40, 24], iconAnchor: [20, 24],
      });
      const marker = L.marker([m.lat, m.lng], { icon }).addTo(layerRef.current);
      marker.bindPopup(`<b>${m.title}</b><br/>${m.location_name}`);
      if (onMarkerClick) marker.on("click", () => onMarkerClick(m));
    });
    if (valid.length && mapRef.current) {
      const group = L.featureGroup(valid.map((m) => L.marker([m.lat, m.lng])));
      try { mapRef.current.fitBounds(group.getBounds().pad(0.3), { maxZoom: 12 }); } catch (e) { console.warn("Map fitBounds failed", e); }
    }
    setTimeout(() => mapRef.current && mapRef.current.invalidateSize(), 200);
  }, [markers]);

  return <div ref={ref} data-testid="map-view" style={{ height, width: "100%" }} className="rounded-md border border-zinc-200 overflow-hidden" />;
};
